<div class="help-dialog-container">
  <h1 mat-dialog-title>{{ helpDialog.title }}</h1>
  <div mat-dialog-content cdkFocusInitial>
    <p class="help-message">
      {{ helpDialog.message }}
    </p>
  </div>
  <div mat-dialog-actions>
    <button (click)="onClick()" class="help-button">Ok</button>
  </div>
</div>
